export default class Single {
    constructor() {
        this.init();
    }

    init() {
        this.slide();
        this.setBackBtn();
    }

    setBackBtn() {
        const backbtn = document.querySelector(".works__single__back a");
        const savedBack = window.sessionStorage.getItem("yet_works_backURL");

        if (backbtn && savedBack) {
            backbtn.setAttribute("href", savedBack);
        }
    }

    slide() {
        //document.querySelector(".l-main").style.display = "none";
        const thumb = [...document.querySelectorAll(".js-works_slide__thumb")];
        const slides = [...document.querySelectorAll(".js-works_slide")];
        const number = document.querySelector(".js-works_slide__number");

        thumb.forEach((el) => {
            el.addEventListener("click", () => {
                const index = el.getAttribute("data-index");
                const tgt = document.querySelector(`.js-works_slide[data-index='${index}']`);
                slides.forEach((el) => el.classList.remove("-active"));
                tgt && tgt.classList.add("-active");

                thumb.forEach((el) => el.classList.remove("-active"));
                el.classList.add("-active");

                number.innerHTML = Number(index) + 1;
            });
        });
    }
}
